import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, Navigate } from 'react-router-dom';
import './index.css';
import { AuthProvider, useAuth } from './AuthContext';
import { signOutUser } from './firebase';
import Upload from './pages/Upload';
import JobProgress from './pages/JobProgress';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Viewer from './pages/Viewer';

function Nav() {
  const loc = useLocation();
  const { user } = useAuth();
  if (!user) return null;
  return (
    <nav style={{
      position:'fixed',top:0,left:0,right:0,zIndex:100,
      background:'rgba(12,12,13,0.92)',backdropFilter:'blur(16px)',
      borderBottom:'1px solid var(--border)',
      padding:'0 32px',display:'flex',alignItems:'center',height:52,
    }}>
      <Link to="/" style={{textDecoration:'none',display:'flex',alignItems:'center',gap:10}}>
        <div style={{width:24,height:24,position:'relative',display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{width:16,height:16,border:'1.5px solid var(--rust)',borderRadius:3,transform:'rotate(15deg)',position:'absolute'}}/>
          <div style={{width:8,height:8,background:'var(--rust)',borderRadius:1.5,transform:'rotate(15deg)'}}/>
        </div>
        <span style={{fontFamily:'IBM Plex Mono,monospace',fontWeight:500,fontSize:14,color:'var(--white)'}}>civil3d</span>
        <span style={{
          fontFamily:'IBM Plex Mono,monospace',fontSize:9,
          color:'rgba(255,255,255,0.55)',
          letterSpacing:'0.08em',marginLeft:4,
          borderLeft:'1px solid rgba(255,255,255,0.12)',
          paddingLeft:10,whiteSpace:'nowrap',
        }}>by Black Vanilla</span>
      </Link>
      <div style={{flex:1}}/>
      <div style={{display:'flex',alignItems:'center',gap:16}}>
        {loc.pathname !== '/upload' && (
          <Link to="/upload" className="btn btn-primary btn-sm">+ New Scan</Link>
        )}
        {user.photoURL && <img src={user.photoURL} alt="" style={{width:24,height:24,borderRadius:'50%',opacity:0.8}}/>}
        <span style={{fontSize:12,color:'var(--muted)',fontFamily:'IBM Plex Mono,monospace',maxWidth:160,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
          {user.email}
        </span>
        <button onClick={signOutUser} style={{background:'none',border:'none',color:'var(--muted)',cursor:'pointer',fontSize:11,fontFamily:'IBM Plex Mono,monospace'}}>
          sign out
        </button>
      </div>
    </nav>
  );
}

function AppFooter() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div style={{
      borderTop:'1px solid var(--border)',
      padding:'16px 32px',
      display:'flex',alignItems:'center',justifyContent:'space-between',
      flexWrap:'wrap',gap:12,
      background:'var(--surface)',
    }}>
      <div style={{display:'flex',alignItems:'center',gap:10}}>
        <svg viewBox="4 3 74 62" width="20" height="16" style={{flexShrink:0}}>
          <circle cx="64" cy="24" r="2.5" fill="#C8F04A" opacity="1"/>
          <circle cx="58" cy="20.5" r="2.35" fill="#C8F04A" opacity="0.9"/>
          <circle cx="52" cy="17" r="2.2" fill="#C8F04A" opacity="0.8"/>
          <circle cx="64" cy="31" r="2.35" fill="#C8F04A" opacity="0.9"/>
          <circle cx="58" cy="27.5" r="2.2" fill="#C8F04A" opacity="0.8"/>
          <circle cx="40" cy="17" r="2.0" fill="#C8F04A" opacity="0.85"/>
          <circle cx="16" cy="24" r="2.1" fill="#A8D040" opacity="0.65"/>
          <circle cx="22" cy="20.5" r="1.99" fill="#A8D040" opacity="0.6"/>
        </svg>
        <span style={{fontFamily:'IBM Plex Mono,monospace',fontSize:10,color:'rgba(255,255,255,0.55)',letterSpacing:'0.06em'}}>
          civil3d is a{' '}
          <a href="https://blackvanilla.ai" target="_blank" rel="noreferrer"
            style={{color:'#C8F04A',textDecoration:'none',fontWeight:500}}>
            Black Vanilla Technologies
          </a>
          {' '}platform
        </span>
      </div>
      <div style={{display:'flex',gap:20,alignItems:'center',flexWrap:'wrap'}}>
        <a href="https://blackvanilla.ai#terms" target="_blank" rel="noreferrer"
          style={{fontFamily:'IBM Plex Mono,monospace',fontSize:9,color:'rgba(255,255,255,0.4)',textDecoration:'none',letterSpacing:'0.08em',textTransform:'uppercase',transition:'color 0.2s'}}
          onMouseEnter={e=>e.target.style.color='rgba(255,255,255,0.75)'}
          onMouseLeave={e=>e.target.style.color='rgba(255,255,255,0.4)'}>
          Terms
        </a>
        <a href="https://blackvanilla.ai#privacy" target="_blank" rel="noreferrer"
          style={{fontFamily:'IBM Plex Mono,monospace',fontSize:9,color:'rgba(255,255,255,0.4)',textDecoration:'none',letterSpacing:'0.08em',textTransform:'uppercase',transition:'color 0.2s'}}
          onMouseEnter={e=>e.target.style.color='rgba(255,255,255,0.75)'}
          onMouseLeave={e=>e.target.style.color='rgba(255,255,255,0.4)'}>
          Privacy
        </a>
        <a href="https://blackvanilla.ai" target="_blank" rel="noreferrer"
          style={{fontFamily:'IBM Plex Mono,monospace',fontSize:9,color:'rgba(255,255,255,0.4)',textDecoration:'none',letterSpacing:'0.08em',transition:'color 0.2s'}}
          onMouseEnter={e=>e.target.style.color='#C8F04A'}
          onMouseLeave={e=>e.target.style.color='rgba(255,255,255,0.4)'}>
          blackvanilla.ai ↗
        </a>
        <span style={{fontFamily:'IBM Plex Mono,monospace',fontSize:9,color:'rgba(255,255,255,0.2)',letterSpacing:'0.06em'}}>
          © 2026 Black Vanilla Technologies
        </span>
      </div>
    </div>
  );
}

function RequireAuth({ children }) {
  const { user } = useAuth();
  if (user === undefined) return (
    <div style={{height:'100vh',display:'flex',alignItems:'center',justifyContent:'center',color:'var(--muted)',fontFamily:'IBM Plex Mono,monospace',fontSize:12}}>
      Loading...
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Nav />
        <div style={{paddingTop:52}}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/upload" element={<RequireAuth><Upload /></RequireAuth>} />
            <Route path="/jobs/:jobId" element={<RequireAuth><JobProgress /></RequireAuth>} />
            <Route path="/viewer/:jobId" element={<RequireAuth><Viewer /></RequireAuth>} />
          </Routes>
        </div>
        <AppFooter />
      </Router>
    </AuthProvider>
  );
}
